import {LoaderArgs, redirect} from '@shopify/remix-oxygen';

import {BaseLayout} from '~/modules/Layout/components/BaseLayout';
import CollectionPage from '~/modules/Collections/components/CollectionPage';
import {SeoHandleFunction} from '@shopify/hydrogen';
import {getLoaderExpertName} from '~/modules/Common/util';
import {getPaginatedCollection} from '~/modules/Product/loaders/collectionsLoader';

const seo: SeoHandleFunction<typeof loader> = ({data: {collection}}) => {
  return {
    title: collection?.name || 'Collection',
    description: collection.description || '',
  };
};
export const handle = {
  seo,
};

export async function loader({
  context: {storefront, client},
  params,
  request,
}: LoaderArgs) {
  const expertName = getLoaderExpertName(params, request);
  if (!expertName) {
    return redirect('/404');
  }

  if (expertName === 'newbrand') {
    return redirect('/brand-user/login');
  }

  if (expertName === 'demostore') {
    return redirect('/expert/login');
  }

  const {collection, shopifyProducts, products} = await getPaginatedCollection(
    params.id!,
    expertName,
    storefront,
    {client, filterVisible: true, page: 1, limit: 12},
  );

  if (!collection) {
    return redirect('/404');
  }
  return {
    collection,
    products,
    shopifyProducts,
    isSubdomain: !params.expertName,
    expertName,
  };
}

export default function Page() {
  return (
    <BaseLayout>
      <CollectionPage />
    </BaseLayout>
  );
}
